/* eslint-disable max-len */
import { Box, Button, Stack, Typography } from '@mui/material';
import ContainerPainel from 'components/container_painel';
import { Loading } from 'components/login';
import { useAuth } from 'contexts/auth/auth_context';
import { UserPermissionEnum } from 'enum/userPermission.enum';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import useComunidadesRuraisTradicionaisStore from 'stores/forms/comunidades_rurais_tradicionais';
import { Step1 } from './steps/step1';
import { FormularioComunidadesFormik } from 'interfaces/formularioComunidades.interface';



const FormularioComunidadesQuilombolasEditar: React.FC = () => {
  const { uuid } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  // Estados para cada step
  const { getComunidadesRuraisTradicionais, loading, setPartialForm, enviarAprovacao, saveDraftForm } = useComunidadesRuraisTradicionaisStore();
  const [open, setOpen] = useState(false);

  const formik = useFormik({
    initialValues: {
      anoReferencia: new Date().getFullYear().toString(),
      assentamentos: [],
      comunidades: []
    } as FormularioComunidadesFormik,
    onSubmit: (values) => {

      if (values.assentamentos.length === 0 && values.comunidades.length === 0) {
        alert('É necessário informar pelo menos um assentamento ou comunidade');
        return;
      }
      setPartialForm('assentamentos', values.assentamentos);
      setPartialForm('comunidades', values.comunidades);
      setTimeout(() => {
        enviarAprovacao();
        handleFinalSubmit();
      }, 100);
    }
  })

  const handleSalvarComoRascunho = () => {
    const values = formik.values;
    setPartialForm('assentamentos', values.assentamentos);
    setPartialForm('comunidades', values.comunidades);
    setTimeout(() => {
      saveDraftForm();
      alert('Rascunho salvo com sucesso');
      handleFinalSubmit();
    }, 100);
  }

  const usuariosPermitidos = [
    UserPermissionEnum.MUNICIPAL_MANAGER,
    UserPermissionEnum.ADMIN,
  ];

  const isUsuarioPermitido = usuariosPermitidos.includes(
    user?.permission.name as UserPermissionEnum,
  );

  useEffect(() => {
    handleGetComunidadesRuraisTradicionais();
  }, [uuid]);

  const handleGetComunidadesRuraisTradicionais = async () => {
    const response = await getComunidadesRuraisTradicionais(uuid as string) as unknown as FormularioComunidadesFormik & { ano_referencia_do_questionario: string };
    const values: FormularioComunidadesFormik = {
      anoReferencia: response.ano_referencia_do_questionario,
      assentamentos: response.assentamentos,
      comunidades: response.comunidades
    }
    formik.setValues(values);

  }

  const handleFinalSubmit = () => {
    navigate(ROUTES.PACOTE_FORMULARIOS);
  };

  return (
    <ContainerPainel
      pagina='Formulário de Comunidades Rurais e Tradicionais'
      showBackButton={true}
    >
      {isUsuarioPermitido ? (
        <Stack marginX={'4rem'} paddingTop={'2rem'}>

          {loading ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Loading />
            </Box>
          ) : (
            <>
              <Step1
                onNext={() => { }}
                formik={formik}
                open={open}
                setOpen={setOpen}
              />
              <Box
                display={'flex'}
                justifyContent={'flex-end'}
                gap={2}
                mt={4}
                width={'100%'}
              >
                {/* voltar um formulario */}

                <Button variant='outlined' color='primary' onClick={handleFinalSubmit} disabled={open}>
                  Voltar
                </Button>

                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleSalvarComoRascunho}
                  disabled={open}
                >
                  Salvar como rascunho
                </Button>

                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  disabled={open}
                >
                  Enviar para aprovação
                </Button>

              </Box>
            </>
          )}
        </Stack>
      ) : (
        <Stack
          sx={{
            marginX: '4rem',
            paddingTop: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            backgroundColor: '#FFF',
            borderRadius: '1rem',
            padding: '2rem',
            margin: '2rem',
          }}
        >
          <Typography>
            Você não tem permissão para editar este formulário
          </Typography>
          <Button onClick={() => navigate(ROUTES.PACOTE_FORMULARIOS)}>
            Voltar
          </Button>
        </Stack>
      )}
    </ContainerPainel>
  );
};

export default FormularioComunidadesQuilombolasEditar;
